import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Loading from '../../_Lessons/Notes/Loading';
import { setInterviewed } from '../../../utils/Api';

export default ({ id, onSuccess, onBack }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Modal isOpen={true} className="modal-lg">
      {isLoading ? (
        <Loading style={{ position: 'static' }} />
      ) : (
        <React.Fragment>
          <ModalHeader style={{ justifyContent: 'center' }}><i className="fa fa-comments" /></ModalHeader>
          <ModalBody style={{ textAlign: 'center' }}>
            <FormattedMessage id="mytrainings_training_interview" />
          </ModalBody>
          <ModalFooter style={{ justifyContent: 'center' }}>
            <Button color="primary" onClick={onBack}>
              <FormattedMessage id="overall_input_back" />
            </Button>
            <Button
              color="success"
              onClick={() => {
                setIsLoading(true);
                setInterviewed(id).then(() => onSuccess());
              }}
            >
              <FormattedMessage id="overall_input_confirm" />
            </Button>
          </ModalFooter>
        </React.Fragment>
      )}
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/views/_MyTrainings/List/ModalConfirm.js